import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useSessionId, ThemeContext, useAuthProvider, useDataProvider, Result, DataContext, callApi, Loader } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import DataTable from  "@cloudpremise/portal_core/src/themes/mui/examples/Tables/DataTable";
import AccountModal from "../components/JsforceAccountModal";
import Confirmation from  "@cloudpremise/portal_core/src/themes/mui/components/Modals/Confirmation";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Card from "@mui/material/Card";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import EditIcon from "@mui/icons-material/Edit";
import PreviewIcon from "@mui/icons-material/Preview";
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from "@azure/msal-react";
import { Account } from "../types";


const Jsforce = (props) => {
    const dataProvider = useContext(DataContext);
    const defaultState = {
        page: 1,
        callApi: true,
        loading: false,
        loadingMore: false,
        response: null,
        viewMore: false,
        RF_LIMIT: 2,
        RF_OFFSET: 0,
        showLoadMore: false,
        cancelToken: null,
        RF_ORDER_BY: null,
        errorMessage: null,
        saving: false,
        sortColumn: 'Name',
		sortColumnDirection: {
			Name: 'asc',
		},
		items: [],
		selection: [],
        searchText: "",
        accountModal: false,
        accounts: null,
        dataTableRef: React.createRef(),
        row: null
    };
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);
    const [ authorized, authType ] = useAuthProvider();
    const navigate = useNavigate();

    const record: Account = {
        sObjectTypeName: "Account",
        url: "/v1/sobject",
        params: {
            query: "SELECT Id, Name, Phone, CreatedDate, Website FROM Account"
        }
    }
    const [loading, data, adapterState, setAdapterState] = useDataProvider(record, {
        'provider': 'jsforce'
    }, false, (data: Result) => {
        let errorMessage = null;
        if(data.hasOwnProperty("error") && data.error !== null){
            errorMessage = data.error;
        }
        setState({
            accounts: data,
            errorMessage: errorMessage
        });
    });

    React.useEffect(() => {
        if(authorized && (authType !== "salesforce")){
            return navigate("/auth-not-supported", { replace: true });
        }
    });

    function handleChanged(event, data){
        setState({
            selection: data.selection
        });
	};

	function handleSort(sortColumn, ...rest){
		if (props.log) {
			props.log('sort')(sortColumn, ...rest);
		}

		const sortProperty = sortColumn.property;
		const { sortDirection } = sortColumn;
		const newState = {
            ...state,
			sortColumn: sortProperty,
			sortColumnDirection: {
				[sortProperty]: sortDirection,
			},
			items: [...state.items],
		};

		
        setState(newState);
	}
    function handleFilterChange(event){
        setState({
            searchText: event.target.value,
            isFiltering: true
        });
	}

    function onRowClick(event, row){
        event.preventDefault();
        console.log(row);
        setState({
            itemModal: true,
            item: row
        });
    }

    function getTableData(){
        const { accounts } = state;
        let rows = [];
        if(accounts && Array.isArray(accounts.result)){
            rows = accounts.result;
        }
        const tableData = {
            columns: [
                {
                    Header: "Id",
                    accessor: "Id",
                    Cell: (instance) => {
                        return (
                            <Link color="info" href="/" onClick={(event) => onRowClick(event, instance.row.values)}>
                                {instance.value}
                            </Link>
                        )
                    },
                },
                {
                    Header: "Name",
                    accessor: "Name",
                },
                {
                    Header: "AccountId",
                    accessor: "AccountId",
                },
                {
                    Header: "Email",
                    accessor: "Email",
                },
                {
                    Header: "Phone",
                    accessor: "Phone",
                },
                { Header: "Actions", accessor: "actions", width: "12%" },
            ],
            rows: rows
        };
        const items = [];
        rows.map((row, key) => {
            const itemObj = {
                ...row,
                key: (key + 1),
                id: row.Id,
            };
            items.push({
                ...itemObj,
                onClick: () => { handleRowAction(itemObj, {value: "edit"}) },
                actions: (
                    <>
                        <MDButton
                            variant="gradient"
                            color="info"
                            onClick={() => handleRowAction(row, {value: "edit"})}
                            iconOnly
                            style={{marginRight: "5px"}}
                            size="small"
                        >
                            {(row.isClosed ? <PreviewIcon /> : <EditIcon />)}
                        </MDButton>
                        <MDButton
                            variant="gradient"
                            color="error"
                            onClick={() => handleRowAction(row, {value: "delete"})}
                            iconOnly
                            size="small"
                        >
                            <CloseIcon />
                        </MDButton>
                    </>
                )
            });
            return null;
        });
        tableData.rows = items;
        return tableData;
    }
    function handleRowAction(item, action){
        let newState = {
            [action.value+"Modal"]: true
        };
        if(item !== null){
            newState['row'] = item;
        }
        setState(newState);      
	}
    function handleRowClick(event, item){
        setState({
            row: item
        });
	}
    function handleLoadMore(){
        if(!adapterState.hasMore || state.workers === null || adapterState.callApi || adapterState.loading){
            return;
        }
        setAdapterState({
            loading: false,
            callApi: true,
            RF_OFFSET: adapterState.RF_OFFSET + state.RF_LIMIT
        });
    }
    function getSortColumnName(){
        const columns = {
            key: "Number",
            Id: "Id",
            Name: "Name",
            Email: "Email",
            AccountId: "AccountId",
            Phone: "Phone"
        };
        return columns;
    }
    function onAccountModal(status = true){
        setState({
            editModal: false,
            accountModal: status
        });
    }
    function onAccountModalSuccess(data){
        console.log("On Success", data);
        if(state.editModal){
            state.accounts.result.map((account, key) => {
                if(account.Id === data.Id){
                    state.accounts.result[key] = data;
                }
                return null;
            });
        }else{
            if(state.accounts === null){
                state.accounts = {
                    result: []
                }
            }
            state.accounts.result.push(data);
        }
        setState({
            editModal: false,
            accountModal: false,
            accounts: state.accounts,
            errorMessage: null
        });
    }
    function onDeleteModalSuccess(){
        const { row } = state;
        const deleteRecord: Account = {
            sObjectTypeName: "Account",
            url: "/v1/sobject",
            method: 'DELETE',
            params: {
                sobjecttypename: "Account",
                Id: row.Id
            },
            headers: {},
            data: {}
        }
        callApi(dataProvider, deleteRecord).then(data => {
            state.accounts.result.map((item, key) => {
                if(item.Id === row.Id){
                    state.accounts.result.splice(key, 1);
                }
                return null;
            });
            setState({
                editModal: false,
                accountModal: false,
                deleteModal: false,
                accounts: state.accounts,
            });  
        }).catch(err => {
            setState({
                saving: false,
                errorMessage: err.message
            });
        });

        setState({
            saving: true,
            errorMessage: null
        });
    }
    function onConfirmationModal(status = true){
        setState({
            accountModal: false,
            deleteModal: status,
            errorMessage: null
        });
    }
    const tableData = getTableData();
    console.log(state);
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={2}>
                <Card>
                    <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" p={2}>
                        <h3>Jsforce Accounts sObject API Demo (MP)</h3>
                        <MDButton
                            variant="gradient"
                            color="info"
                            onClick={() => onAccountModal()}
                        >
                            New Account
                        </MDButton>
                    </MDBox>
                    {
                        loading ?
                            <Loader p={2} color="info" />
                        :
                            state.errorMessage !== null ?
                                <Stack p={2}>
                                    <Alert severity="error">{state.errorMessage}</Alert>
                                </Stack>
                            :
                                <DataTable
                                    table={getTableData()}
                                    canSearch={false}
                                    isSorted={false}
                                    entriesPerPage={false}
                                    rowsCount={tableData.rows.length}
                                    manualPagination
                                    loading={adapterState.viewMore}
                                />
                    }
                </Card>
            </MDBox>
            {
                state.accountModal ?
                    <AccountModal
                        open={state.accountModal}
                        onCancel={() => onAccountModal(false)}
                        onSuccess={onAccountModalSuccess}
                    />
                :
                null
            }
            {
                state.editModal ?
                    <AccountModal
                        open={state.editModal}
                        item={state.row}
                        onCancel={() => onAccountModal(false)}
                        onSuccess={onAccountModalSuccess}
                        onDelete={onDeleteModalSuccess}
                        onObjectAction={(action) => handleRowAction(state.row, {value: action})}
                    />
                :
                null
            }
            {
                state.deleteModal ?
                    <Confirmation
                        open={state.deleteModal}
                        item={state.row}
                        onCancel={() => onConfirmationModal(false)}
                        onSuccess={onDeleteModalSuccess}
                        message={"Are you sure you want to delete?"}
                        saving={state.saving}
                        errorMessage={state.errorMessage}
                    />
                :
                null
            }
        </DashboardLayout>
    )
}

export default Jsforce;